import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Email categories
    addEmailCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/email-categories', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEmailCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/email-categories/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEmailCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/email-categories/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEmailCategories(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/email-categories', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // Email categories
    // Email address
    addEmailAddress(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/email-address', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addEmailAddressBulk(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/email-address-bulk', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEmailAddress(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/email-address/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEmailAddress(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/email-address/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEmailAddress(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/email-address/${data.category_id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
